module.exports = __webpack_public_path__ + "static/service-dev-9890b0530e602f40ccf5551ad255324b.jpg";